import { store } from "@betacrew/jars-flux";
import { componentKey, setDeleteFormsModalOpen, setFormDetails, setFormDetailsDrawerOpen, setFormsList, setLoadingState, setPaginationState, setPayersList, setSelectedForm, setSelectedForms, setSelectedPayer, setSelectedTaxYear, setSubmittedForms, setTaxYearsList, setSubmittedFormsDetails, setFeeData, setSubmitFormFees, setLoadFormsDataState, setSubmitForThisPayerModal, setCategorisedFormFields, setFormDetailsDrawerLoader, setSubmitForThisPayerReviewedCheckboxModal, setSubmitForThisPayerReviewedCheckbox, setAssignFormsToReviewersModal, updateForm1094cStatusObj, setCheckFor1094cStatus, setShouldGetSubmittedFormsGridData, setEnableScheduleDate, setFiltersLoadingState, setIsFormGridLoading } from "./FormListingSlice";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import FormsDataService from "../../../../services/FormsDataService";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import General from "../../../../libs/utility/General";
import SubmitFormsDataService from "../../../../services/SubmitFormsDataService";
import { COMMON_LOADING_STATES, PAGE_STATE } from "../../constants/constants";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import { FORM_LISTING_LOADING_STATES, READY_TO_SUBMIT_CHECKBOX } from "./constants";
import { setReadyToSubmitTabCheckboxes } from "./FormListingSlice";
import Forms from "../../../../libs/utility/formsutility/Forms";
import PaymentDataService from "../../../../services/PaymentDataService";
import { FORM_NAMS } from "../manageforms/managefederalforms/statefiling/constants";
import RightsManagementDataService from "../../../../services/RightsManagementDataService";

export const { getFormsList, getSubmittedForms, getTaxYears, getPayersBySelectedForm, deleteForms, deleteSingleForm, downloadMultiplePDF, createZipForDownloadAll, downloadSinglePDF, exportToExcel, updateReadyToSubmitTabCheckboxes, calculateTax1099FeeAmount, submitForSinglePayer, loadFormsData, getFormFields, assignFormToReviewers, getForm1094CStatus, getEnableScheduleDate, clearList } = {

    getFormsList: (payload) => {
        return {
            type: "FORMS_LISTING/GET_FORMS",
            payload
        }
    },
    getSubmittedForms: (payload) => {
        return {
            type: "FORMS_LISTING/GET_SUBMITTED_FORMS",
            payload
        }
    },
    getTaxYears: (payload) => {
        return {
            type: "FORMS_LISTING/GET_TAX_YEARS",
            payload
        }
    },
    getPayersBySelectedForm: (payload) => {
        return {
            type: "FORMS_LISTING/GET_PAYERS_BY_FORM",
            payload
        }
    },
    deleteForms: (payload) => {
        return {
            type: "FORMS_LISTING/DELETE_FORMS",
            payload
        }
    },
    deleteSingleForm: (payload) => {
        return {
            type: "FORMS_LISTING/DELETE_SINGE_FORM",
            payload
        }
    },
    downloadMultiplePDF: (payload) => {
        return {
            type: "FORMS_LISTING/DOWNLOAD_MULTIPLE_PDF",
            payload
        }
    },
    downloadSinglePDF: (payload) => {
        return {
            type: "FORMS_LISTING/DOWNLOAD_SINGLE_PDF",
            payload
        }
    },
    createZipForDownloadAll: (payload) => {
        return {
            type: "FORMS_LISTING/CREATE_ZIP_FOR_DOWNLOAD_ALL",
            payload
        }
    },
    exportToExcel: (payload) => {
        return {
            type: "FORMS_LISTING/EXPORT_TO_EXCEL",
            payload
        }
    },
    updateReadyToSubmitTabCheckboxes: (payload) => {
        return {
            type: "FORMS_LISTING/UPDATE_READY_TO_SUBMIT_CHECKBOXES",
            payload
        }
    },

    calculateTax1099FeeAmount: (payload) => {
        return {
            type: "FORMS_LISTING/CALCULATE_TAX_AMOUNT",
            payload
        }
    },
    submitForSinglePayer: (payload) => {
        return {
            type: "FORMS_LISTING/SUBMIT_FOR_SINGLE_PAYER",
            payload
        }
    },
    loadFormsData: (payload) => {
        return {
            type: "FORMS_LISTING/LOAD_FORMS_DATA",
            payload
        }
    },

    getFormFields: (payload) => {
        return {
            type: "FORMS_LISTING/GET_FORM_FIELDS",
            payload
        }
    },
    assignFormToReviewers: (payload) => {
        return {
            type: "FORMS_LISTING/ASSIGN_FORM_TO_REVIEWERS",
            payload
        }
    },
    getForm1094CStatus: (payload) => {
        return {
            type: "FORMS_LISTING/GET_FORM_1094C_STATUS",
            payload
        }
    },
    getEnableScheduleDate: (payload) => {
        return {
            type: "FORMS_LISTING/GET_SHCEDULE_DATE_BUTTON_STATUS",
            payload
        }
    },
    clearList: (payload) => {
        return {
            type: "FORMS_LISTING/CLEAR_LIST",
            payload
        }
    },
}

function* getFormsListAsync(action) {

    try {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }));

        const { formId } = action.payload;

        const response = yield FormsDataService.getFormsList();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const formList = [...Data.Forms];
            General.addOptionAndValueKeys(formList, "FormLabel", "Id")
            const formListWFormId = formList.map(item => { return { ...item, FormId: item.Id, FormName1: item.FormLabel, FormShortName: item?.FormId } });

            yield put(setFormsList(formListWFormId));

            const form = formListWFormId.find(form => form.Id == formId);

            if (formId && form) {
                if (form) {
                    yield put(setSelectedForm(form))
                } else {
                    const MISC_FORM = formListWFormId.find(form => form.FormLabel == FORM_NAMS.$1099_MISC);

                    if (MISC_FORM) {
                        yield put(setSelectedForm(MISC_FORM))
                    }
                }
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch forms list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch forms list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_READY }));
    }

}

function* getTaxYearsAsync(action) {

    try {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_TAX_YEARS_LOADING }));

        const { formId, taxYear } = action?.payload;

        const response = yield FormsDataService.getCascadeTaxYears(formId);

        const { Message, Status, Data } = response?.data;

        if (Status) {

            const yearsList = Data.map(year => {
                return { ...year, label: year.ID, value: year.ID, itemName: year.ID }
            })

            yield put(setTaxYearsList(yearsList));

            if (taxYear) {
                const year = yearsList.find(year => year.value == taxYear);
                if (year) {
                    yield put(setSelectedTaxYear(year));
                } else {
                    yield put(setSelectedTaxYear(yearsList[0]))
                }
            } else {
                yield put(setSelectedTaxYear(yearsList[0]))
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch tax years", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch tax years", message: error?.response?.data?.Message }));
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_TAX_YEARS_READY }));
    }

}

function* getPayersBySelectedFormAsync(action) {

    try {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_PAYERS_LOADING }));

        const { formId, payerId } = action.payload;

        const response = yield FormsDataService.getCascadePayers(formId);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const payersList = [...Data];
            General.addOptionAndValueKeys(payersList, "LastName", "PayerDetailId");

            yield put(setPayersList(payersList));

            if (payerId) {
                const payer = payersList.find(payer => payer.value == payerId);

                if (payer) {
                    yield put(setSelectedPayer(payer));
                }
            } else {
                yield put(setSelectedPayer(payersList[0]))
            }

        } else {
            yield put(addNotifications({ heading: "Failed to fetch payers", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch payers", message: error?.response?.data?.Message }));
    } finally {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_PAYERS_READY }));
    }

}

function* getSubmittedFormsAsync(action) {

    try {
        yield put(setIsFormGridLoading(true))
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORM_LIST_LOADING }))

        const payload = Forms.getSubmittedFormsCreatePayload(action.payload)

        const response = yield SubmitFormsDataService.getSubmittedFormsList(payload);

        const { Message, Status, Data } = response?.data ?? {};

        if (Status) {
            if(Data){
                if(Data?.Data && Array.isArray(Data?.Data)){
                    yield put(setSubmittedForms(Data.Data))
                    yield put(setSelectedForms([...Data.Data.filter((form) => form?.IsSelect)]))
                }else{
                    yield put(setSubmittedForms([]))
                    yield put(setSelectedForms([]))
                }
                            
                yield* setCheckboxes(Data);
    
                const responseDatObj = { ...Data };
    
                delete responseDatObj.Data;
                yield put(setSubmittedFormsDetails(responseDatObj))
                yield put(setCheckFor1094cStatus(true))
                yield put(setPaginationState({ total: Data?.Total }))
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch the submitted forms", message: Message || "" }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the submitted forms", message: error?.response?.data?.Message || "" }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORM_LIST_READY }))
        yield put(setIsFormGridLoading(false))
    }

}

function* setCheckboxes(Data) {
    yield put(setReadyToSubmitTabCheckboxes(
        { 
            [READY_TO_SUBMIT_CHECKBOX.SELECT_ALL]: Data?.IsGlobalAllSelected ?? false,
            [READY_TO_SUBMIT_CHECKBOX.EMAIL_RECIPIENT]: Data?.IsGlobalEmailSelected ?? false,
            [READY_TO_SUBMIT_CHECKBOX.STATE_FILING]: Data?.IsGlobalStateSelected ?? false,
            [READY_TO_SUBMIT_CHECKBOX.TIN_MATCH]: Data?.IsGlobalTinMatchSelected ?? false,
            [READY_TO_SUBMIT_CHECKBOX.USPS_MAIL]: Data?.IsGlobalUSPSSelected ?? false
        }
    ));
}

function* deleteFormsAsync(action) {

    try {
        const { submittedForms, selectedReadyToSubmitForms, selectedForm, fromDrawer = false } = action.payload;

        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_FROM_DRAWER_LOADING : FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_LOADING }))

        let jsonData = submittedForms.map(item => {
            let obj = {
                value: item.FormId, ScheduleDate: "", EmailKey: item.IsEmailRecipient, UspsKey: item.IsUSPSMail, TinKey: item.IsTinCheck, StateKey: item.IsState, State: "", Foreignkey: "0"
            };

            obj.key = selectedReadyToSubmitForms.some(selectedItem => selectedItem.FormId === item.FormId);

            return obj;
        });

        const data = {
            jsonPreferences: jsonData,
            formId: selectedForm.value,
            formName: selectedForm.label
        }

        const response = yield SubmitFormsDataService.deleteForms(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setDeleteFormsModalOpen({ state: false }))
            yield put(setFormDetailsDrawerOpen(false))
            yield put(setShouldGetSubmittedFormsGridData({
                gridData: true,
                updatePagination: false,
            }))
            yield put(setSelectedForms([]))
            yield put(addNotifications({ heading: "Form successfully deleted!", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(setDeleteFormsModalOpen({ state: false }))
            yield put(addNotifications({ heading: "Failed to delete selected forms", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        console.log(error)
        yield put(setDeleteFormsModalOpen({ state: false }))
        yield put(addNotifications({ heading: "Failed to delete selected forms", message: error?.response?.data?.Message }));
        const { fromDrawer = false } = action?.payload;
        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_FROM_DRAWER_READY : FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_READY }))
    } finally {
    }

}

function* deleteSingleFormAsync(action) {

    try {
        const { formSubmissionId, formId, fromDrawer = false } = action.payload;

        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.DELETE_SINGLE_FORM_FROM_DRAWER_LOADING : FORM_LISTING_LOADING_STATES.DELETE_SINGLE_FORM_LOADING }))

        const response = yield SubmitFormsDataService.deleteSingleForm({ formSubmissionId, formId });

        const { Message, Status } = response?.data;

        if (Status) {
            yield put(setDeleteFormsModalOpen({ state: false }))
            yield put(setFormDetailsDrawerOpen(false))
            yield put(setShouldGetSubmittedFormsGridData({
                gridData: true,
                updatePagination: false,
            }))
            yield put(setSelectedForms([]))
            yield put(addNotifications({ heading: "Form successfully deleted!", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(setDeleteFormsModalOpen({ state: false }))
            yield put(addNotifications({ heading: "Failed to delete selected forms", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        console.log(error)
        yield put(setDeleteFormsModalOpen({ state: false }))
        yield put(addNotifications({ heading: "Failed to delete selected forms", message: error?.response?.data?.Message }));
        const { fromDrawer } = action?.payload;
        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.DELETE_SINGLE_FORM_FROM_DRAWER_READY : FORM_LISTING_LOADING_STATES.DELETE_SINGLE_FORM_READY }))
    } finally {
    }

}

function* createZipForDownloadAllAsync(action) {

    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.CREATE_ZIP_LOADING }))

        const { payer, formName, taxYear, submittedForms, selectedReadyToSubmitForms, maskTin = false } = action.payload

        const data = {
            jsonPreferences: Forms.getJsonPreferences(submittedForms, selectedReadyToSubmitForms, formName),
            payerName: payer.label,
            payerId: payer.PayerDetailId,
            ReferenceNo: null,
            partNumber: null,
            maskTin: maskTin,
            pdfCopy: "payee",
            formName: formName,
            taxYear: parseInt(taxYear),
            sourcePage: "Submit",
            isCorrected: false,
            mergeCopies: false
        }

        const response = yield SubmitFormsDataService.createZipForDownloadAll(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(downloadMultiplePDF({ fileName: Data.EncryptedPayerName, formName: Data.FormName }))
        } else {
            yield put(addNotifications({ heading: "Failed to create zip file", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to create zip file", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.CREATE_ZIP_READY }))
    }

}

function* downloadMultiplePDFAsync(action) {

    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_LOADING }))

        const { fileName, formName } = action.payload

        const response = yield SubmitFormsDataService.downloadMultiplePDF(fileName, formName);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name)
            yield put(addNotifications({ heading: "Successfully downloaded multiple PDFs.", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to download multiple pdf", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download multiple pdf", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_READY }))
    }

}

function* downloadSinglePDFAsync(action) {

    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.DOWNLOAD_SINGLE_PDF_LOADING }))

        const { highlightedForm, selectedForm, selectedPayer, viewOnly = false, isUnMask = false } = action.payload

        const data = {
            "formId": highlightedForm.FormId,
            "PayerId": selectedPayer.PayerDetailId,
            "formTypeId": selectedForm.value,
            "isUnMask": isUnMask,
            "employerId": 0
        }

        const response = yield SubmitFormsDataService.downloadSinglePDF(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (viewOnly) {
                General.openBase64FileInNewTab(Data.Base64, Data.Name);
            } else {
                General.downloadFileFromBase64(Data.Base64, Data.Name)
                yield put(addNotifications({ heading: "PDF downloaded successfully.", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            }
        } else {
            yield put(addNotifications({ heading: viewOnly ? "Failed to open a PDF" : "Failed to download a PDF", message: Message }));
        }

    } catch (error) {
        const { viewOnly = false } = action?.payload
        console.log(error)
        yield put(addNotifications({ heading: viewOnly ? "Failed to open a PDF" : "Failed to download a PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.DOWNLOAD_SINGLE_PDF_READY }))
    }

}

function* exportToExcelAsync(action) {

    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.EXPORT_TO_EXCEL_LOADING }))

        const { selectedForm, selectedPayer, selectedTaxYear, formType = "" } = action.payload

        const data = {
            payerId: selectedPayer.PayerDetailId,
            formId: selectedForm.value,
            taxyear: Number(selectedTaxYear.label),
            formName: selectedForm.label,
            status: "Not Submitted",
            formtype: formType?.value ?? "",
        }

        const response = yield SubmitFormsDataService.exportToExcel(data);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name)
            yield put(addNotifications({ heading: "Downloaded successfully.", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to download", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.EXPORT_TO_EXCEL_READY }))
    }
}

function* updateReadyToSubmitTabCheckboxesAsync(action) {
    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORM_LIST_LOADING }))

        const { checkboxName, checkboxValue, selectAllCheckBox } = action?.payload;
        let response = {};

        switch (checkboxName) {
            case READY_TO_SUBMIT_CHECKBOX.SELECT_ALL:
                response = yield SubmitFormsDataService.rtsSelectAllCheckbox({ flag: checkboxValue })
                break;

            case READY_TO_SUBMIT_CHECKBOX.USPS_MAIL:
                response = yield SubmitFormsDataService.rtsUSPSMailCheckbox({ flag: checkboxValue })
                break;

            case READY_TO_SUBMIT_CHECKBOX.EMAIL_RECIPIENT:
                response = yield SubmitFormsDataService.rtsRecipientMailCheckbox({
                    flag: checkboxValue,
                    page: 1,
                    pageSize: 0,
                    isSelectAllChecked: selectAllCheckBox
                })
                break;

            case READY_TO_SUBMIT_CHECKBOX.TIN_MATCH:
                response = yield SubmitFormsDataService.rtsTinMatchCheckbox({ flag: checkboxValue })
                break;

            case READY_TO_SUBMIT_CHECKBOX.STATE_FILING:
                response = yield SubmitFormsDataService.rtsStateFilingCheckbox({ flag: checkboxValue })
                break;
        }

        if (response?.data?.Status) {
            yield put(setReadyToSubmitTabCheckboxes({ [checkboxName]: checkboxValue }))
        } else {
            yield put(addNotifications({ heading: "Failed to update the checkbox", message: response?.data?.Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to update the checkbox", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORM_LIST_READY }))
    }
}

function* calculateTax1099FeeAmountAsync(action) {
    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.CALCULATE_FEE_AMOUNT_LOADING }));

        const { formsList, selectedFormsList, payerId, totalAmount, formName, payerName, taxYear } = action?.payload;
        const jsonPreferences = Forms.getJsonPreferences(formsList, selectedFormsList);

        const payload = {
            jsonPreferences,
            payerId,
            totalAmount,
            formName,
            payerName,
            taxYear
        }

        const response = yield SubmitFormsDataService.calculateTax1099FeeAmount(payload);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setFeeData(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to calculate the amount", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to calculate the amount", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.CALCULATE_FEE_AMOUNT_READY }))
    }
}

function* submitForSinglePayerAsync(action) {
    try {
        const { PayerId, FormName, readyToSubmitTabCheckboxes, IsCorrected, TaxYear, PayerName, submittedForms, selectedReadyToSubmitForms, fromDrawer, openSubmitForThisPayerModal = true, highlightedForm = null, considerAllSelectedFormsForThisPayer } = action?.payload;

        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_LOADING : FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_LOADING }));        

        const data = {
            PayerId,
            FormName,
            IsCorrected,
            TaxYear,
            PayerName,
            IsEMailRecipient: readyToSubmitTabCheckboxes?.emailRecipientCheckbox,
            IsUSPSRecipient: readyToSubmitTabCheckboxes?.uspsMailCheckbox,
            IsStateFiling: readyToSubmitTabCheckboxes?.stateFilingCheckbox,
            FormModel: Forms.getJsonPreferences(submittedForms, selectedReadyToSubmitForms, "", (fromDrawer && !considerAllSelectedFormsForThisPayer ? highlightedForm : null)),
        }

        const response = yield SubmitFormsDataService.submitForSinglePayer(data);

        if (response?.data) {
            const { Message, Status, Data } = response?.data;

            if (Status) {
                yield put(setSubmitFormFees(Data));

                if (openSubmitForThisPayerModal) {
                    yield put(setSubmitForThisPayerModal(true));
                }
            } else {
                yield put(addNotifications({ heading: "Failed to submit form for this payer", message: Message }));
            }
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to submit form for this payer", message: error?.response?.data?.Message }));
    } finally {
        const { fromDrawer = false, openSubmitForThisPayerModal = true } = action?.payload;
        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_READY : FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_READY }));

        if (openSubmitForThisPayerModal) {
            yield put(setFormDetailsDrawerOpen(false));
        }
    }
}

function* loadFormsDataAsync(action) {
    try {
        const { PayerId, selectedForm, TaxYear, filingType, submitType, formType, fromDrawer = false, fromVerificationPopup, considerAllSelectedFormsForThisPayer } = action?.payload;

        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING : FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_LOADING }));

        const data = {
            payerId: PayerId,
            formId: selectedForm?.value,
            formType: formType?.value,
            taxYear: TaxYear,
            formname: selectedForm?.label,
            statustype: "NotSubmitted",
            filingType: filingType,
            jsonPreferences: null,
            request: null
        }

        const response = yield SubmitFormsDataService.loadFormsData(data);

        if (response?.data) {
            const { Message, Status, Data } = response?.data;

            if (Status) {
                yield put(setLoadFormsDataState({ state: true, type: submitType, fromDrawer, fromVerificationPopup, considerAllSelectedFormsForThisPayer }));
            } else {
                yield put(addNotifications({ heading: "Failed to load form data", message: Message }));
            }
        }

    } catch (error) {
        console.log('loadFormsDataAsync: ', error)
        yield put(addNotifications({ heading: "Failed to load form data", message: error?.response?.data?.Message }));

        const { fromDrawer, fromVerificationPopup = false } = action?.payload;

        yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_READY : FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_READY }));

        if (fromVerificationPopup) {
            yield put(setSubmitForThisPayerReviewedCheckboxModal(false));
            yield put(setSubmitForThisPayerReviewedCheckbox(false));
        }
    }
}

function* assignFormToReviewersAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }));

        const { formIds, payerId, formName, payerName, taxyear, formtypeId, reviewerIds } = action?.payload;

        const params = {
            formIds: formIds.toString(),
            payerId,
            formName,
            payerName,
            taxyear,
            formtypeId,
            reviewerIds: reviewerIds.map(r => r.UserId).toString(),
        }

        const response = yield RightsManagementDataService.submitforReview(params);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setAssignFormsToReviewersModal(false));
            yield put(setFormDetailsDrawerOpen(false));
            yield put(setSelectedForms([]))
            yield put(setShouldGetSubmittedFormsGridData({
                gridData: true,
                updatePagination: false,
            }))
        } else {
            yield put(addNotifications({ heading: "Failed to assign forms to reviewers", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to assign forms to reviewers", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
    }
}

function* getForm1094CStatusAsync(action) {
    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORM_LIST_LOADING }))

        const { payerId } = action?.payload;
        const response = yield SubmitFormsDataService.getForm1094CStatus(payerId);

        if (response.data) {
            if (response?.data?.Status === 1 || response?.data?.Status === 0) {
                yield put(updateForm1094cStatusObj({
                    isAvailable: true,
                    formStatus: response?.data?.Status ? true : false,
                }));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORM_LIST_READY }))
    }
}

function* getEnableScheduleDateAsync(action) {
    try {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.GET_CHANGE_SCHEDULE_DATE_STATUS_LOADING }));
        
        const data  = action.payload;

        const response = yield SubmitFormsDataService.getScheduledDatesStatus(data);
        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(setEnableScheduleDate(Data));
        } else {
            yield put(addNotifications({ heading: "Failed to get change schedule date status", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get change schedule date status", message: error?.response?.data?.Message }));
    } finally {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.GET_CHANGE_SCHEDULE_DATE_STATUS_READY }))
    }
}

function* clearListAsync(action){
    try {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }));

        const response = yield SubmitFormsDataService.clearList();

        const { Message, Status, Data } = response?.data;

        if (!Status) {
            yield put(addNotifications({ heading: "Error", message: Message }));   
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFormsList().type, getFormsListAsync),
        takeLatest(getSubmittedForms().type, getSubmittedFormsAsync),
        takeLatest(getTaxYears().type, getTaxYearsAsync),
        takeLatest(getPayersBySelectedForm().type, getPayersBySelectedFormAsync),
        takeLatest(deleteForms().type, deleteFormsAsync),
        takeLatest(deleteSingleForm().type, deleteSingleFormAsync),
        takeLatest(downloadMultiplePDF().type, downloadMultiplePDFAsync),
        takeLatest(createZipForDownloadAll().type, createZipForDownloadAllAsync),
        takeLatest(downloadSinglePDF().type, downloadSinglePDFAsync),
        takeLatest(exportToExcel().type, exportToExcelAsync),
        takeLatest(updateReadyToSubmitTabCheckboxes().type, updateReadyToSubmitTabCheckboxesAsync),
        takeLatest(calculateTax1099FeeAmount().type, calculateTax1099FeeAmountAsync),
        takeLatest(submitForSinglePayer().type, submitForSinglePayerAsync),
        takeLatest(loadFormsData().type, loadFormsDataAsync),
        takeLatest(assignFormToReviewers().type, assignFormToReviewersAsync),
        takeLatest(getForm1094CStatus().type, getForm1094CStatusAsync),
        takeLatest(getEnableScheduleDate().type, getEnableScheduleDateAsync),
        takeLatest(clearList().type, clearListAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);